export const artworkKey = (value) => String(value || "").trim().toLowerCase()
  .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function resolveVehicleArtwork(vehicle, artworks) {
  const make = artworkKey(vehicle.make);
  const model = artworkKey(vehicle.model);
  const generation = artworkKey(vehicle.generationId || vehicle.generationLabel);
  const variant = artworkKey(vehicle.variantId || vehicle.trim);
  const year = Number(vehicle.year);
  const eligible = artworks.filter((art) => art.status === "approved" && art.currentApprovedVersion &&
    art.makeKey === make && art.modelKey === model);
  const tiers = [
    eligible.filter((art) => generation && variant && art.generationKey === generation && art.variantKey === variant),
    // Never silently substitute a different variant. Generic generation masters are reusable.
    eligible.filter((art) => generation && art.generationKey === generation && !art.variantKey),
    eligible.filter((art) => year && (art.startYear != null || art.endYear != null) &&
      (!art.startYear || year >= art.startYear) && (!art.endYear || year <= art.endYear) &&
      (!art.variantKey || !variant || art.variantKey === variant)),
  ];
  for (const candidates of tiers) {
    if (candidates.length) return { status: candidates.length === 1 ? "matched" : "selection-required", candidates };
  }
  // Model-only results require explicit selection, including incomplete vehicle metadata.
  return { status: eligible.length ? "selection-required" : "unavailable", candidates: eligible };
}
